import React from 'react';

import { useCountdownWithAutomaticRepaint } from '#/components/basic/progress/countdownHook';

function FundingCountdown({ fundingDate }: { fundingDate: number }) {
  // const isMobile = useSelector(state => state.screen.isMobile);
  const { days, hours, minutes, seconds } = useCountdownWithAutomaticRepaint({
    to: fundingDate,
    onComplete: () => {
      // TODO: we should reset funding countdown now
    },
  });
  return (
    <>
      {/* Not expected, but just in case also display days when bigger than 0 */}
      {days ? `${days}:` : ''}
      {hours}:{minutes}:{seconds}
    </>
  );
}

export default FundingCountdown;
